(function () {
    "use strict";

    window.app = angular.module("app", []);
    window.app.config(function ($sceProvider) {
        $sceProvider.enabled(true); // Ensure $sce is enabled
    });

})();